import { gql } from '@apollo/client';

export const CREATE_CONTRACT_AGREEMENT_PERCH = gql`
  mutation Flex_CreateContractAgreementPerch($input: CreateContractAgreementsPerchInput!) {
    createContractAgreementsPerch(input: $input) {
      success
    }
  }
`;
